/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import { getProductUrlForDAM } from '@tcp/core/src/utils/utils';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/BIATile.style';

const BIATile = (props) => {
  const { className, biaProduct, onQuickViewOpenClick } = props;
  const { uniqueId = '', primaryBrand } = biaProduct || {};
  const itemBrand = primaryBrand;

  const imageUrl = getProductUrlForDAM(uniqueId);

  const IMG_DATA_CLP = {
    imgConfig: ['t_plp_img_m,f_auto', 't_plp_img_t,f_auto', 't_plp_img_d,f_auto'],
  };
  const imageData = {
    alt: 'name',
    url: getProductUrlForDAM(uniqueId),
  };

  const addToBag = () => {
    onQuickViewOpenClick({
      colorProductId: uniqueId,
    });
  };

  return (
    <BodyCopy component="div" className={`${className} bia-tile`}>
      <BodyCopy component="div" className="tileWrapper bia-tileWrapper">
        <BodyCopy component="div" className="product-image-container">
          <BodyCopy component="div" className="images-container">
            <div
              onClick={() => {
                addToBag();
              }}
              role="button"
              tabIndex="0"
            >
              <DamImage
                imgData={imageData}
                imgConfigs={IMG_DATA_CLP.imgConfig}
                isProductImage
                imageURL={imageUrl}
                itemBrand={itemBrand}
                width="120px"
                height="153px"
                className={'product-image'}
                onClick={addToBag}
              />
            </div>
          </BodyCopy>
        </BodyCopy>
      </BodyCopy>
    </BodyCopy>
  );
};

BIATile.propTypes = {
  className: PropTypes.string,
  orderItem: PropTypes.shape({}),
};

BIATile.defaultProps = {
  className: '',
};

export default withStyles(BIATile, styles);
export { BIATile as BIATileVanilla };
